import {
  StackModalContextProvider,
  StatefulConnectContextProvider,
} from '@rango-dev/internal-profile/hooks';
import React from 'react';

import './App.css';
import './reset.css';
import { AppRouter } from './AppRouter';

function App(): JSX.Element {
  return (
    <StackModalContextProvider>
      <StatefulConnectContextProvider>
        <AppRouter />
      </StatefulConnectContextProvider>
    </StackModalContextProvider>
  );
}

export default App;
